import React from 'react'
import {
  Modal as ChakraModal,
  ModalBody,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
} from '@chakra-ui/react'

const Modal = ({
  title,
  onClose,
  size,
  isOpen,
  closable,
  scrollBehavior = 'inside',
  renderContent = () => {},
  hideTitle,
  hideFooter,
  ...props
}) => {
  return (
    <ChakraModal
      blockScrollOnMount={false}
      scrollBehavior={scrollBehavior}
      onClose={onClose}
      size={size}
      isOpen={isOpen}
      {...props}
    >
      <ModalOverlay />
      <ModalContent style={{ width: 'calc(100vw - 40px)', margin: '0 20px' }}>
        {hideTitle ? null : <ModalHeader>{title}</ModalHeader>}
        {closable ? (
          <ModalCloseButton _focusVisible={{ border: '2px solid', borderColor: 'black' }} />
        ) : null}
        <ModalBody>{renderContent()}</ModalBody>
        {hideFooter ? null : <ModalFooter></ModalFooter>}
      </ModalContent>
    </ChakraModal>
  )
}

export default Modal
